let selectedText = null;

export default function currentText(state = selectedText, action) {
  switch (action.type) {
    case 'UPDATE_CURRENT_TEXT':
      state = action.payload === null ? action.payload : +action.payload;
      return state;
    default:
      return state
  }
}